import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isNil from 'lodash/isNil';

import { FORMATS } from '../../../../const/ActionsConst';
import FormatManagement from '@common/components/FormatManagement';

import '../../styles/Formats.scss';

export default class Formats extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        data: PropTypes.objectOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            })
        ),
        className: PropTypes.string,
    };

    state = {
        currentEditingFormatProps: {
            opened: false,
            id: undefined,
            name: undefined,
            type: undefined,
        }
    };

    get formats() {
        return [
            {
                label: I18n.t('Individual Datasheet'),
                type: FORMATS.datasheet.individual,
            },
            {
                label: I18n.t('Pedigree Datasheet'),
                type: FORMATS.datasheet.pedigree,
            },
            {
                label: I18n.t('Show Spreadsheet'),
                type: FORMATS.spreadsheet.individual,
            },
            {
                label: I18n.t('Subtext Format'),
                type: FORMATS.subtext,
            },
            {
                label: I18n.t('Symbol Format'),
                type: FORMATS.symbols,
            },
            {
                label: I18n.t('Pedigree Fields'),
                type: FORMATS.pedigreeDropFields,
            },
        ];
    }

    onEdit = (e) => {
        e.persist();

        const { id, name, type } = e.currentTarget.dataset;

        this.setState((state) => ({
            ...state,
            currentEditingFormatProps: {
                opened: true,
                id,
                name,
                type,
            },
        }));
    }

    closeManagement = () => {
        const { clearFolders, clearFormats } = this.props;

        this.setState((state) => ({
            ...state,
            currentEditingFormatProps: {
                opened: false,
            },
        }));
        clearFolders();
        clearFormats();
    }

    onDelete = (e) => {
        e.persist();

        const { type } = e.currentTarget.dataset;
        const { name, onChange, data } = this.props;
        const updatedFormats = {
            ...data,
            [type]: null,
        };
        
        onChange(name, updatedFormats);
    }

    onFormatChange = (format) => {
        const { name, onChange, data } = this.props;
        const updatedFormats = {
            ...data,
            [this.state.currentEditingFormatProps.type]: { id: format.id }
        };
        
        onChange(name, updatedFormats);
        this.closeManagement();
    }

    getFolders = () => {
        const { currentEditingFormatProps } = this.state;

        return this.props.getFolders(currentEditingFormatProps.type)
    }

    getFormats = (folderId) => {
        const { currentEditingFormatProps } = this.state;

        return this.props.getFormats(currentEditingFormatProps.type, folderId)
    }

    render() {
        const { data, className, folders, formats } = this.props;
        const { currentEditingFormatProps } = this.state;
        
        return (
            <div className={cx("User-details-settings-formats", className)}>
                {currentEditingFormatProps.opened && (
                    <FormatManagement 
                        folders={folders}
                        formats={formats}
                        getFolders={this.getFolders}
                        getFormats={this.getFormats}
                        close={this.closeManagement}
                        onSubmit={this.onFormatChange}
                    />
                )}
                {this.formats.map(({ label, type }, index) => {
                    const format = data[type] || {};
                    const { name, id } = format;
                    const noFormat = isNil(data[type]);

                    return (
                        <div key={type} className="User-details-settings-formats__item">
                            <span id={'lbl-settings-name-item' + index} className="User-details-settings-formats__item__label">{label}:</span>
                            <div id={'tx-settings-name-item' + index} className="User-details-settings-formats__item__value">{name}</div>
                            <i
                                id={'i-settings-edit-item' + index}
                                data-id={id}
                                data-name={name}
                                data-type={type}
                                className="fa fa-edit User-details-settings-formats__item__edit-icon" 
                                onClick={this.onEdit}
                            />
                            <i
                                id={'i-settings-delete-item' + index}
                                data-type={type}
                                className={cx('fa fa-times User-details-settings-formats__item__delete-icon', { 'User-details-settings-formats__item--disabled': noFormat })}
                                onClick={noFormat ? undefined : this.onDelete}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}